<template>
  <div>
    <div class="history">
      <div
        v-for="date in dateList"
        :key="date.postId"
        class="history__list"
        :class="{ 'active': datePicked === date.postId}"
        @click="chooseDate(date)"
      >
        <a class="history__round" :class="{ 'active-border ': datePicked === date.postId}"></a>
        {{date.date}}
      </div>
    </div>
    <div class="top-height scroll"></div>
  </div>
</template>

<script>
import { EventBus } from "../../plugins/event-bus.js";
export default {
  data() {
    return {
      dateList: [
        { date: "1750 - 1790", postId: 14, desc: "year1750" },
        { date: "1790 - 1820", postId: 16, desc: "year1790" },
        { date: "1820 - 1850", postId: 17, desc: "year1820" },
        { date: "1850 - 1870", postId: 18, desc: "year1850" },
        { date: "1870 - 1890", postId: 19, desc: "year1870" },
        { date: "1890 - 1905", postId: 20, desc: "year1890" },
        { date: "1905 - 1915", postId: 21, desc: "year1905" },
        { date: "1915 - 1930", postId: 22, desc: "year1915" }
      ],
      datePicked: null
    };
  },
  mounted() {
    EventBus.$on("scroll", () => {
      if (window.innerWidth <= 1200) {
        setTimeout(() => {
          document
            .getElementsByClassName("scroll")[0]
            .scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    });
  },
  methods: {
    chooseDate(date) {
      this.datePicked = date.postId;
      const isUsed = this.$store.state.photos.find(
        photo => photo.postId === this.datePicked
      );
      this.$store.dispatch("activeDesc", date.desc);

      if (!isUsed) {
        return this.$store.dispatch("fetchGalleryPhotos", this.datePicked);
      } else {
        return this.$store.dispatch("changeActiveYearId", this.datePicked);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.top-height {
  height: 7rem;
}
.history {
  padding: 5rem 0 0rem 5rem;
  width: auto;
  @include flex(flex-start, flex-start, column);
  position: relative;
  @include respond(phone) {
    @include flex(center, flex-start, column);
  }
  &__round {
    left: -4rem;
    width: 1rem;
    height: 1rem;
    top: 55%;
    border-radius: 50%;
    background-color: $white;
    transition: 300ms;
    border: 1px solid lighten($fonts, 50%);
    position: absolute;
    &:before {
      content: "";
      left: 0.5rem;
      top: 1.1rem;
      width: 1px;
      height: 6rem;
      position: absolute;
      background-color: $timeline;
    }
  }
  &__list {
    position: relative;
    cursor: pointer;
    font-size: 4.8rem;
    min-width: 25rem;
    font-weight: 400;
    margin-bottom: 2rem;
    color: lighten($fonts, 50%);
    transition: 200ms;
    &:hover {
      color: $fonts;
    }
    @include respond(phone) {
      font-size: 3.8rem;
    }
    &:last-child {
      .history__round {
        &::before {
          display: none;
        }
      }
    }
  }
}
.active {
  color: $fonts;
  padding-left: 1rem;
  @include respond(phone) {
    padding-left: 0;
  }
}
.active-border {
  background-color: $fonts;
  border: 1px solid $fonts;
}
</style>